module.exports = __webpack_public_path__ + "img/img9.92662a58.png";